<fieldset>
  @if (label) {
    <label>
      {{label}}
    </label>
  }
  <div>
    <div>
      <input type="range" [min]="min" [max]="max" [step]="step" class="slider" [ngModel]="privateValue" [ngModelOptions]="{standalone: true}" (ngModelChange)="privateValueChange($event)">
    </div>
    @if (useLabels) {
      <div class="range-values">
        <span>{{minValue}}</span><span>{{viewFormatter(value)}}</span><span>{{maxValue}}</span>
      </div>
    }
  </div>
</fieldset>
